import React from 'react';
import { Link } from 'react-router-dom';
import Navbar from 'react-bootstrap/Navbar';
import Nav from 'react-bootstrap/Nav';
import Modal from 'react-modal';
import { FaLock, FaArrowLeft, FaCheckCircle, FaEye, FaEyeSlash } from 'react-icons/fa';
import env from "react-dotenv";

let URL = `${env.API_URL}/resetpassword`;

const customStyles = {
  overlay: {
    backgroundColor: 'rgba(0, 0, 0, 0.75)',
    zIndex: 1000
  },
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    border: 'none',
    borderRadius: '20px',
    padding: '0',
    maxWidth: '500px',
    width: '90%',
    boxShadow: '0 20px 60px rgba(0,0,0,0.3)'
  }
};

Modal.setAppElement('#root');

class ResetPassword extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      modalIsOpen: false,
      password: '',
      confirmedPassword: '',
      email: '',
      serverResponse: '',
      isLoading: false,
      emailError: '',
      passwordError: '',
      confirmPasswordError: '',
      showPassword: false,
      showConfirmPassword: false
    };
  }

  onEmailChange = (event) => {
    this.setState({ 
      email: event.target.value,
      emailError: '' 
    });
  }

  onPasswordChange = (event) => {
    this.setState({ 
      password: event.target.value,
      passwordError: '' 
    });
  }

  onPasswordConfirm = (event) => {
    this.setState({ 
      confirmedPassword: event.target.value,
      confirmPasswordError: '' 
    });
  }

  validateEmail = (email) => {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(email);
  }

  validatePassword = (password) => {
    return password.length >= 8;
  }

  onSubmitSignIn = () => {
    let hasError = false;

    if (!this.state.email) {
      this.setState({ emailError: 'Please enter your email address' });
      hasError = true;
    } else if (!this.validateEmail(this.state.email)) {
      this.setState({ emailError: 'Please enter a valid email address' });
      hasError = true;
    }

    if (!this.state.password) {
      this.setState({ passwordError: 'Please enter a password' });
      hasError = true;
    } else if (!this.validatePassword(this.state.password)) {
      this.setState({ passwordError: 'Password must be at least 8 characters' });
      hasError = true;
    }

    if (!this.state.confirmedPassword) {
      this.setState({ confirmPasswordError: 'Please confirm your password' });
      hasError = true;
    } else if (this.state.password !== this.state.confirmedPassword) {
      this.setState({ confirmPasswordError: 'Passwords do not match' });
      hasError = true;
    }

    if (hasError) return;

    this.setState({ isLoading: true });

    fetch(URL, {
      method: 'post',
      headers: {'Content-Type': 'application/json',
      'Authorization': env.API_KEY},
      body: JSON.stringify({
        password: this.state.password,
        confirmedPassword: this.state.confirmedPassword,
        email: this.state.email
      })
    }).then(response => response.json())
      .then(data  => {
        if(data){
          this.setState({ 
            serverResponse: data,
            modalIsOpen: true,
            isLoading: false
          });
        }
      })
      .catch(error => {
        this.setState({ 
          serverResponse: 'An error occurred. Please try again.',
          modalIsOpen: true,
          isLoading: false
        });
      });
  }

  handleKeyPress = (event) => {
    if (event.key === 'Enter') {
      this.onSubmitSignIn();
    }
  }

  togglePasswordVisibility = () => {
    this.setState({ showPassword: !this.state.showPassword });
  }

  toggleConfirmPasswordVisibility = () => {
    this.setState({ showConfirmPassword: !this.state.showConfirmPassword });
  }

  render() {
    const { 
      emailError, 
      passwordError, 
      confirmPasswordError, 
      isLoading,
      showPassword,
      showConfirmPassword 
    } = this.state;

    return (
      <div style={{ 
        minHeight: '100vh', 
        background: 'linear-gradient(135deg, #1e3a8a 0%, #3b82f6 50%, #60a5fa 100%)',
        paddingTop: '70px',
        paddingBottom: '70px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}>
        {/* Top Navbar */}
        <Navbar expand="sm" fixed="top" style={{ 
          background: 'rgba(255, 255, 255, 0.95)',
          backdropFilter: 'blur(10px)',
          boxShadow: '0 2px 20px rgba(0,0,0,0.1)'
        }}>
          <Link to="/" style={{ marginLeft: '1rem' }}>
            <img src="/images/p10.jpg" alt="Logo" style={{ height: '40px', borderRadius: '8px' }} />
          </Link>
          <Nav className="ml-auto" style={{ marginRight: '1rem' }}>
            <Link to="/" style={{ 
              color: '#1e3a8a', 
              textDecoration: 'none',
              fontWeight: '600',
              display: 'flex',
              alignItems: 'center',
              gap: '0.5rem'
            }}>
              <FaArrowLeft /> Back to Sign In
            </Link>
          </Nav>
        </Navbar>

        {/* Main Content */}
        <div style={{ 
          maxWidth: '500px',
          width: '90%',
          margin: '0 auto'
        }}>
          <div style={{
            background: 'white',
            borderRadius: '20px',
            padding: '3rem 2.5rem',
            boxShadow: '0 20px 60px rgba(0,0,0,0.2)',
            animation: 'fadeIn 0.5s ease'
          }}>
            {/* Icon */}
            <div style={{
              textAlign: 'center',
              marginBottom: '2rem'
            }}>
              <div style={{
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: '80px',
                height: '80px',
                borderRadius: '50%',
                background: 'linear-gradient(135deg, #3b82f6 0%, #60a5fa 100%)',
                marginBottom: '1.5rem',
                boxShadow: '0 8px 20px rgba(59, 130, 246, 0.3)'
              }}>
                <FaLock style={{ fontSize: '2.5rem', color: 'white' }} />
              </div>
              <h1 style={{ 
                fontSize: '2rem',
                fontWeight: '700',
                marginBottom: '0.5rem',
                color: '#1e3a8a'
              }}>
                Reset Your Password
              </h1>
              <p style={{ 
                color: '#718096',
                fontSize: '1rem',
                lineHeight: '1.6'
              }}>
                Confirm your email and enter your new password below.
              </p>
            </div>

            {/* Email Input */}
            <div style={{ marginBottom: '1.5rem' }}>
              <label 
                htmlFor="email" 
                style={{ 
                  display: 'block',
                  fontWeight: '600',
                  marginBottom: '0.5rem',
                  color: '#1e3a8a',
                  fontSize: '0.95rem'
                }}
              >
                Email Address
              </label>
              <input
                type="email"
                name="email"
                id="email"
                placeholder="your@email.com"
                onChange={this.onEmailChange}
                onKeyPress={this.handleKeyPress}
                style={{
                  width: '100%',
                  padding: '0.875rem 1rem',
                  fontSize: '1rem',
                  border: emailError ? '2px solid #ef4444' : '2px solid #e2e8f0',
                  borderRadius: '12px',
                  outline: 'none',
                  transition: 'all 0.3s ease',
                  boxSizing: 'border-box'
                }}
                onFocus={(e) => {
                  if (!emailError) {
                    e.target.style.borderColor = '#3b82f6';
                    e.target.style.boxShadow = '0 0 0 3px rgba(59, 130, 246, 0.1)';
                  }
                }}
                onBlur={(e) => {
                  e.target.style.borderColor = emailError ? '#ef4444' : '#e2e8f0';
                  e.target.style.boxShadow = 'none';
                }}
              />
              {emailError && (
                <p style={{
                  color: '#ef4444',
                  fontSize: '0.875rem',
                  marginTop: '0.5rem',
                  marginBottom: '0'
                }}>
                  {emailError}
                </p>
              )}
            </div>

            {/* New Password Input */}
            <div style={{ marginBottom: '1.5rem' }}>
              <label 
                htmlFor="password" 
                style={{ 
                  display: 'block',
                  fontWeight: '600',
                  marginBottom: '0.5rem',
                  color: '#1e3a8a',
                  fontSize: '0.95rem'
                }}
              >
                New Password
              </label>
              <div style={{ position: 'relative' }}>
                <input
                  type={showPassword ? 'text' : 'password'}
                  name="password"
                  id="password"
                  placeholder="Enter new password"
                  onChange={this.onPasswordChange}
                  onKeyPress={this.handleKeyPress}
                  style={{
                    width: '100%',
                    padding: '0.875rem 3rem 0.875rem 1rem',
                    fontSize: '1rem',
                    border: passwordError ? '2px solid #ef4444' : '2px solid #e2e8f0',
                    borderRadius: '12px',
                    outline: 'none',
                    transition: 'all 0.3s ease',
                    boxSizing: 'border-box'
                  }}
                  onFocus={(e) => {
                    if (!passwordError) {
                      e.target.style.borderColor = '#3b82f6';
                      e.target.style.boxShadow = '0 0 0 3px rgba(59, 130, 246, 0.1)';
                    }
                  }}
                  onBlur={(e) => {
                    e.target.style.borderColor = passwordError ? '#ef4444' : '#e2e8f0';
                    e.target.style.boxShadow = 'none';
                  }}
                />
                <button
                  type="button"
                  onClick={this.togglePasswordVisibility}
                  style={{
                    position: 'absolute',
                    right: '1rem',
                    top: '50%',
                    transform: 'translateY(-50%)',
                    background: 'none',
                    border: 'none',
                    cursor: 'pointer',
                    color: '#718096',
                    fontSize: '1.2rem',
                    padding: '0.25rem'
                  }}
                >
                  {showPassword ? <FaEyeSlash /> : <FaEye />}
                </button>
              </div>
              {passwordError && (
                <p style={{
                  color: '#ef4444',
                  fontSize: '0.875rem',
                  marginTop: '0.5rem',
                  marginBottom: '0'
                }}>
                  {passwordError}
                </p>
              )}
              <p style={{
                color: '#718096',
                fontSize: '0.875rem',
                marginTop: '0.5rem',
                marginBottom: '0'
              }}>
                Must be at least 8 characters
              </p>
            </div>

            {/* Confirm Password Input */}
            <div style={{ marginBottom: '2rem' }}>
              <label 
                htmlFor="confirmed-password" 
                style={{ 
                  display: 'block',
                  fontWeight: '600',
                  marginBottom: '0.5rem',
                  color: '#1e3a8a',
                  fontSize: '0.95rem'
                }}
              >
                Confirm Password
              </label>
              <div style={{ position: 'relative' }}>
                <input
                  type={showConfirmPassword ? 'text' : 'password'}
                  name="confirmed-password"
                  id="confirmed-password"
                  placeholder="Confirm new password"
                  onChange={this.onPasswordConfirm}
                  onKeyPress={this.handleKeyPress}
                  style={{
                    width: '100%',
                    padding: '0.875rem 3rem 0.875rem 1rem',
                    fontSize: '1rem',
                    border: confirmPasswordError ? '2px solid #ef4444' : '2px solid #e2e8f0',
                    borderRadius: '12px',
                    outline: 'none',
                    transition: 'all 0.3s ease',
                    boxSizing: 'border-box'
                  }}
                  onFocus={(e) => {
                    if (!confirmPasswordError) {
                      e.target.style.borderColor = '#3b82f6';
                      e.target.style.boxShadow = '0 0 0 3px rgba(59, 130, 246, 0.1)';
                    }
                  }}
                  onBlur={(e) => {
                    e.target.style.borderColor = confirmPasswordError ? '#ef4444' : '#e2e8f0';
                    e.target.style.boxShadow = 'none';
                  }}
                />
                <button
                  type="button"
                  onClick={this.toggleConfirmPasswordVisibility}
                  style={{
                    position: 'absolute',
                    right: '1rem',
                    top: '50%',
                    transform: 'translateY(-50%)',
                    background: 'none',
                    border: 'none',
                    cursor: 'pointer',
                    color: '#718096',
                    fontSize: '1.2rem',
                    padding: '0.25rem'
                  }}
                >
                  {showConfirmPassword ? <FaEyeSlash /> : <FaEye />}
                </button>
              </div>
              {confirmPasswordError && (
                <p style={{
                  color: '#ef4444',
                  fontSize: '0.875rem',
                  marginTop: '0.5rem',
                  marginBottom: '0'
                }}>
                  {confirmPasswordError}
                </p>
              )}
            </div>

            {/* Submit Button */}
            <button
              onClick={this.onSubmitSignIn}
              disabled={isLoading}
              style={{
                width: '100%',
                padding: '1rem',
                fontSize: '1.1rem',
                fontWeight: '600',
                color: 'white',
                background: isLoading 
                  ? 'linear-gradient(135deg, #94a3b8 0%, #cbd5e1 100%)'
                  : 'linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)',
                border: 'none',
                borderRadius: '12px',
                cursor: isLoading ? 'not-allowed' : 'pointer',
                boxShadow: '0 8px 20px rgba(59, 130, 246, 0.3)',
                transition: 'all 0.3s ease',
                marginBottom: '1rem'
              }}
              onMouseEnter={(e) => {
                if (!isLoading) {
                  e.currentTarget.style.transform = 'translateY(-2px)';
                  e.currentTarget.style.boxShadow = '0 12px 30px rgba(59, 130, 246, 0.4)';
                }
              }}
              onMouseLeave={(e) => {
                if (!isLoading) {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = '0 8px 20px rgba(59, 130, 246, 0.3)';
                }
              }}
            >
              {isLoading ? 'Resetting Password...' : 'Reset Password'}
            </button>

            {/* Help Text */}
            <div style={{
              textAlign: 'center',
              paddingTop: '1rem',
              borderTop: '1px solid #e2e8f0'
            }}>
              <p style={{ 
                color: '#718096',
                fontSize: '0.9rem',
                marginBottom: '0.5rem'
              }}>
                Remember your password?
              </p>
              <Link 
                to="/" 
                style={{
                  color: '#3b82f6',
                  textDecoration: 'none',
                  fontWeight: '600',
                  fontSize: '0.95rem'
                }}
                onMouseEnter={(e) => e.currentTarget.style.textDecoration = 'underline'}
                onMouseLeave={(e) => e.currentTarget.style.textDecoration = 'none'}
              >
                Back to Sign In
              </Link>
            </div>
          </div>
        </div>

        {/* Response Modal */}
        <Modal 
          style={customStyles} 
          isOpen={this.state.modalIsOpen} 
          onRequestClose={() => this.setState({ modalIsOpen: false })}
        >
          <div style={{ padding: '2.5rem', textAlign: 'center' }}>
            <div style={{
              display: 'inline-flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: '70px',
              height: '70px',
              borderRadius: '50%',
              background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
              marginBottom: '1.5rem',
              boxShadow: '0 8px 20px rgba(16, 185, 129, 0.3)'
            }}>
              <FaCheckCircle style={{ fontSize: '2.5rem', color: 'white' }} />
            </div>
            <h2 style={{ 
              fontSize: '1.75rem',
              fontWeight: '700',
              marginBottom: '1rem',
              color: '#1e3a8a'
            }}>
              Password Changed!
            </h2>
            <p style={{ 
              color: '#718096',
              fontSize: '1rem',
              lineHeight: '1.6',
              marginBottom: '2rem'
            }}>
              {this.state.serverResponse}
            </p>
            <Link
              to="/"
              style={{
                display: 'inline-block',
                padding: '0.875rem 2rem',
                fontSize: '1rem',
                fontWeight: '600',
                color: 'white',
                background: 'linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)',
                border: 'none',
                borderRadius: '12px',
                textDecoration: 'none',
                boxShadow: '0 8px 20px rgba(59, 130, 246, 0.3)',
                transition: 'all 0.3s ease'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-2px)';
                e.currentTarget.style.boxShadow = '0 12px 30px rgba(59, 130, 246, 0.4)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = '0 8px 20px rgba(59, 130, 246, 0.3)';
              }}
            >
              Go to Sign In
            </Link>
          </div>
        </Modal>

        {/* Bottom Navbar */}
        <Navbar fixed="bottom" style={{ 
          background: 'rgba(255, 255, 255, 0.95)',
          backdropFilter: 'blur(10px)',
          boxShadow: '0 -2px 20px rgba(0,0,0,0.1)',
          padding: '1rem'
        }}>
          <Nav style={{ 
            width: '100%', 
            display: 'flex', 
            justifyContent: 'center',
            flexWrap: 'wrap',
            gap: '0.5rem'
          }}>
            <span style={{ margin: '0 0.5rem', color: '#4a5568', fontWeight: '500' }}>
              p10rating © 2026
            </span>
            <Link to='/privacypolicy' style={{ margin: '0 0.5rem', color: '#3b82f6', textDecoration: 'none', fontWeight: '500' }}>
              Privacy
            </Link>
            <Link to='/disclaimer' style={{ margin: '0 0.5rem', color: '#3b82f6', textDecoration: 'none', fontWeight: '500' }}>
              Disclaimer
            </Link>
            <Link to='/terms' style={{ margin: '0 0.5rem', color: '#3b82f6', textDecoration: 'none', fontWeight: '500' }}>
              Terms
            </Link>
            <Link to='/signin' style={{ margin: '0 0.5rem', color: '#3b82f6', textDecoration: 'none', fontWeight: '500' }}>
              Sign In
            </Link>
          </Nav>
        </Navbar>

        <style>{`
          @keyframes fadeIn {
            from {
              opacity: 0;
              transform: translateY(20px);
            }
            to {
              opacity: 1;
              transform: translateY(0);
            }
          }
        `}</style>
      </div>
    );
  }
}

export default ResetPassword;